import baseTheme from '../baseTheme';
var MuiFormLabel = {
    root: {
        fontSize: baseTheme.typography.pxToRem(14),
        letterSpacing: '0.02em',
        fontWeight: 700,
        lineHeight: 1.5,
        color: baseTheme.palette.text.primary,
        '&$focused:not($error)': {
            color: baseTheme.palette.text.primary,
        },
    },
};
export default MuiFormLabel;
//# sourceMappingURL=MuiFormLabel.js.map